import { useState } from 'react';
import { Box, Card, TextField, Typography } from '@mui/material';
import { Colors } from '../../../../Styles/Colors';
import { renderTitle, ActionButton } from "./SarasCommonComp";
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import { withTranslation } from 'react-i18next';
import ShowComponents from '../Common/ShowComponent';
import CommonValidation from '../../../../Components/CommonFunctions/CommonValidation';

const SarasObstericData = ({ Title, ...props }) => {
    const [state, setState] = useState({
        obs_PICME: "",
        obs_Abortion: "",
        obs_LiveBirth: "",
        obs_Para: "",
        obs_Gravida: "",
        selected_id: null,
    });

    const updateState = (updates) => {
        setState((prev) => ({ ...prev, ...updates }));
    };

    const getApiCall = () => {
        getObstericData();
    }

    const checkValue = (value) => {
        return (value !== undefined && value !== null);
    }

    const getObstericData = () => {
        try {
            RestAPIService.GetWithoutReplica(Serviceurls.DOC_OBSTETRIC_DATA_GET + `?appointment_id=${props.appointmentId}&patient_id=${props.patientId}`)
                .then((response) => {
                    if (response.data.status === 'success') {
                        const Data = response.data.data ? response.data.data : {};
                        updateState({
                            selected_id: Data?.id || null,
                            obs_PICME: checkValue(Data?.picme) ? Data?.picme : "",
                            obs_Abortion: checkValue(Data?.abortions) ? Data?.abortions : "",
                            obs_LiveBirth: checkValue(Data?.live_births) ? Data?.live_births : "",
                            obs_Para: checkValue(Data?.para) ? Data?.para : "",
                            obs_Gravida: checkValue(Data?.gravida) ? Data?.gravida : "",
                        })
                    }
                }).catch((error) => {
                   props.errorMessage(error?.response?.data?.message || error?.message)
                })
        } catch (error) {
            props.errorMessage(error.message)
        }
    }

    const ClearData = () => {
        updateState({
            obs_PICME: "",
            obs_Abortion: "",
            obs_LiveBirth: "",
            obs_Para: "",
            obs_Gravida: "",
        })
    }

    const PostObstericData = () => {
        try {
            const { appointmentId, patientId } = props
            const data = {
                "patient_id": patientId,
                "appointment_id": appointmentId,
                "last_menstrual_period": null,
                "expected_date_of_delivery": null,
                "gravida": state.obs_Gravida ? +state.obs_Gravida : 0,
                "para": state.obs_Para ? +state.obs_Para : 0,
                "live_births": state.obs_LiveBirth ? +state.obs_LiveBirth : 0,
                "abortions": state.obs_Abortion ? +state.obs_Abortion : 0,
                "picme": state.obs_PICME || "",
            }

            RestAPIService.create(data, Serviceurls.DOC_OBSTETRIC_DATA_GET)
                .then((response) => {
                    if (response.data.status === "success") {
                        props.successMessage(response.data.message)
                        ClearData();
                        getObstericData();
                    } else {
                        props.errorMessage(response.data.message)
                    }
                }).catch(error => {
                    props.errorMessage(error?.response?.data?.message || error?.message)
                })
        } catch (error) {
            props.errorMessage(error.message)
        }
    }

    const returnTextField = (label, stateKey, MaxLength = 15) => {
        const { t } = props;
        return (
            <Box
                sx={{
                    display: 'grid',
                    gridTemplateColumns: '30% 70%',
                    gap: '0.2vw',
                    alignItems: 'center',
                    width: '100%',
                    minWidth: 0,
                }}
            >
                <Typography fontWeight="bold">{t(label)}:</Typography>
                <TextField
                    size="small"
                    fullWidth
                    sx={{ width: '100%' }}
                    inputProps={{ maxLength: MaxLength }}
                    onChange={(e) => {
                        const { value } = e.target;
                        if (CommonValidation.numberOnly(value) || value === "") {
                            updateState({ [stateKey]: value });
                        }
                    }}
                    value={state[stateKey]}
                    autoComplete="off"
                />
            </Box>
        );
    };


    return (
        <ShowComponents onIntersection={getApiCall.bind(this)}>
            <Card sx={{
                width: "100%", height: "fit-content", padding: "0.3vw",
                marginBottom: "0.5vw", border: `2px solid ${props.isSelected ? Colors.themeDark : Colors.white}`
            }}>
                <Box display={"flex"} flexDirection={'row'} alignItems={"center"} justifyContent={'space-between'} padding={"0.5vw"} borderBottom={`1px solid #E3E2E2`}>
                    {renderTitle(Title, props.isSelected)}
                    <Box display="flex" alignItems={"center"} gap={"0.625dvw"}>
                        <ActionButton
                            text={"Clear"}
                            emed_tid='doc_notes_bold_clr'
                            variant={'outlined'}
                            onClick={() => ClearData()}
                        />
                        <ActionButton
                            text={"Save"}
                            emed_tid='doc_notes_bold_save'
                            disabled={state.isDisable ||
                                (!state.obs_PICME && !state.obs_Gravida && !state.obs_Para && !state.obs_LiveBirth && !state.obs_Abortion)
                                || props.isLocked}
                            onClick={() => { PostObstericData() }}
                        />
                    </Box>
                </Box>
                <Box
                    sx={{
                        display: 'grid',
                        gridTemplateColumns: {
                            xs: '1fr',
                            sm: '1fr 1fr',
                        },
                        gap: '0.625vw',
                        width: '100%',
                        padding: '0.625vw',
                        boxSizing: 'border-box',
                    }}
                >
                    {returnTextField("PICME", "obs_PICME")}
                    {returnTextField("Gravida", "obs_Gravida", 10)}
                    {returnTextField("Para", "obs_Para", 10)}
                    {returnTextField("Live Birth", "obs_LiveBirth", 3)}
                    {returnTextField("Abortion", "obs_Abortion", 3)}
                </Box>
            </Card>
        </ShowComponents >
    )
}

export default withTranslation()(SarasObstericData)